export function Alert({ children }: { children: string }) {
  return (
    <div className="rounded-control bg-danger-soft px-4 py-3 text-sm text-danger" role="alert">
      {children}
    </div>
  );
}
